import { sendRequest } from "../libs/axiosConfig";

export const getClientDetailsApi = async (clientId) => {
  const res = await sendRequest({
    method: "get",
    url: `/api/v1/clients/${clientId}`,
  });
  return res;
};

export const updateClientApi = async (clientId, formData) => {
  const res = await sendRequest({
    method: "put",
    url: `/api/v1/clients/${clientId}/updateclient`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res;
};

export const addClientApi = async (reqBody) => {
  const res = await sendRequest({
    method: "post",
    url: `/api/v1/clients/register`,
    body: { ...reqBody },
  });
  return res;
};

export const getClientSWOTApi = async (clientId) => {
  const res = await sendRequest({
    method: "get",
    url: `/api/v1/clients/${clientId}/swot`,
    moduleName: "SWOT View"
  });
  return res;
};

export const getClientAuditStatusApi = async (clientId) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/audityearuploadstatus`,
    method: "GET",
    moduleName: "Upload Statement"
  });
  return res;
};

export const uploadAuditApi = async (clientId, reqBody) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/uploadauditsheet`,
    method: "POST",
    body: { ...reqBody },
  });
  return res;
};

export const getRawAuditSheetsApi = async (clientId, reqBody) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/rawAuditSheets`,
    method: "POST",
    body: { ...reqBody },
  });

  return res;
};

export const getClientClusterwiseApi = async (clientId) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/clusterwise`,
    method: "get",
  });
  return res;
};

export const getZScoreApi = async (clientId) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/zscore`,
    method: "get",
  });
  return res;
};

export const getTrendApi = async (clientId) => {
  const res = await sendRequest({
    url: `/api/v1/clients/${clientId}/trend`,
    method: "get",
  });
  return res;
};